var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState, useEffect, useContext } from "react";
import { Box, Typography, TextField, Button, Card, CardContent, Snackbar, Alert, CircularProgress, Stack, } from "@mui/material";
import { styled } from "@mui/system";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useNavigate } from "react-router-dom";
import { Header } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import SequentLogo from "@sequentech/ui-essentials/public/Sequent_logo.svg";
import BlankLogoImg from "@sequentech/ui-essentials/public/blank_logo.svg";
var StyledApp = styled(Stack)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 100vh;\n    min-width: 100vw;\n    ", "\n"], ["\n    min-height: 100vh;\n    min-width: 100vw;\n    ", "\n"])), function (_a) {
    var css = _a.css;
    return css;
});
export var StyledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    z-index: 1;\n    position: relative;\n    background: ", " !important;\n    color: white !important;\n    border-radius: 5px;\n    border: none;\n    display: flex;\n    outline: \"none\";\n    overflow: hidden;\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: ", " !important;\n        background: ", " !important;\n        box-shadow: none !important;\n    }\n"], ["\n    z-index: 1;\n    position: relative;\n    background: ", " !important;\n    color: white !important;\n    border-radius: 5px;\n    border: none;\n    display: flex;\n    outline: \"none\";\n    overflow: hidden;\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: ", " !important;\n        background: ", " !important;\n        box-shadow: none !important;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.brandColor;
});
var StyledCard = styled(Card)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "100%",
        padding: theme.spacing(2),
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: theme.spacing(1),
    });
});
var BackgroundWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "100%",
        height: "100vh",
        background: theme.palette.lightBackground,
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
    });
});
var ContentWrapper = styled(Box)({
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: 600,
});
var Footer = styled(Typography)({
    position: "absolute",
    bottom: 20,
    fontSize: 12,
    opacity: 0.7,
});
/**
 * The `SelectTenant` component allows users to select a tenant by entering the tenant name.
 *
 * This component performs the following tasks:
 * - Redirects to the main app if the user is already authenticated.
 * - Provides a form for users to enter the tenant name.
 * - Validates the tenant name and checks if the tenant exists in the database.
 * - Checks if the Keycloak realm associated with the tenant exists.
 * - Stores the tenant ID in local storage.
 * - Initializes Keycloak without auto-redirect.
 * - Redirects to the login page if not already authenticated.
 * - Displays error messages if any step fails.
 *
 * @component
 * @returns {JSX.Element} The rendered component.
 *
 * @example
 * ```tsx
 * import { SelectTenant } from './SelectTenant';
 *
 * function App() {
 *   return <SelectTenant />;
 * }
 *
 * export default App;
 * ```
 */
export var SelectTenant = function () {
    var t = useTranslation().t;
    var _a = useContext(AuthContext), isAuthenticated = _a.isAuthenticated, initKeycloak = _a.initKeycloak;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _b = useState(""), tenant = _b[0], setTenant = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(0), intents = _e[0], setIntents = _e[1];
    var _f = useState(null), error = _f[0], setError = _f[1];
    var _g = useState(false), open = _g[0], setOpen = _g[1];
    var _h = useState(false), isDisabled = _h[0], setIsDisabled = _h[1];
    var navigate = useNavigate();
    var _j = useState(BlankLogoImg), logoImg = _j[0], setLogoImg = _j[1];
    var _k = useState(""), css = _k[0], setCss = _k[1];
    /**
     * Fetches the default tenant's information from the backend and updates the logo and CSS state.
     *
     * This function sends a POST request to the HASURA_URL endpoint with a GraphQL query to fetch
     * the tenant details by ID. It then extracts the logo URL and CSS from the tenant's annotations
     * and updates the corresponding state variables.
     *
     * @async
     * @function getDefaultTenant
     *
     * @returns {Promise<void>} A promise that reso lves when the tenant information has been fetched and the state has been updated.
     *
     * @throws {Error} Throws an error if the fetch request fails or if the response contains errors.
     */
    var getDefaultTenant = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, data, errors, newLogoState, newCss;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, fetch(globalSettings.HASURA_URL, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            query: "\n                query GetTenantById($id: uuid!) {\n                    sequent_backend_tenant(where: {id: {_eq: $id}}) {\n                        id\n                        slug\n                        annotations\n                        }\n                        }\n                        ",
                            variables: { id: globalSettings.DEFAULT_TENANT_ID },
                        }),
                    })];
                case 1:
                    response = _d.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _d.sent(), data = _a.data, errors = _a.errors;
                    newLogoState = (_b = data === null || data === void 0 ? void 0 : data.sequent_backend_tenant[0].annotations) === null || _b === void 0 ? void 0 : _b.logo_url;
                    newCss = (_c = data === null || data === void 0 ? void 0 : data.sequent_backend_tenant[0].annotations) === null || _c === void 0 ? void 0 : _c.css;
                    setLogoImg((errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? SequentLogo : (newLogoState !== null && newLogoState !== void 0 ? newLogoState : SequentLogo));
                    setCss(newCss !== null && newCss !== void 0 ? newCss : "");
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        // Check for previous attempts
        var nextAttempt = localStorage.getItem("next-tenant-attempt");
        if (nextAttempt) {
            var now = new Date();
            var attemptTime = new Date(nextAttempt);
            var diffMinutes = (now.getTime() - attemptTime.getTime()) / (1000 * 60);
            if (diffMinutes < 5) {
                setError("Too many attempts. Please try again later.");
                setOpen(true);
                setIsDisabled(true);
            }
            else {
                localStorage.removeItem("next-tenant-attempt");
                setIsDisabled(false);
            }
        }
        setTimeout(function () {
            setLoading(false);
        }, 500);
    }, []);
    useEffect(function () {
        if (isAuthenticated) {
            navigate("/"); // Redirect to the app if already authenticated
        }
    }, [isAuthenticated, navigate]);
    useEffect(function () {
        if (globalSettings) {
            getDefaultTenant(); // Redirect to the app if already authenticated
        }
    }, [globalSettings]);
    var handleClose = function (event) {
        setOpen(false);
    };
    /**
     * Check if a Keycloak realm exists
     * @param baseUrl - The Keycloak server URL
     * @param realmName - The name of the realm to check
     * @returns Promise resolving to true if realm exists, false otherwise
     */
    /**
     * Check if a realm exists using a simple fetch request instead of initializing Keycloak
     * This prevents unwanted redirects to Keycloak
     */
    var checkIfRealmExists = function (realmName) { return __awaiter(void 0, void 0, void 0, function () {
        var baseUrl, configUrl, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    baseUrl = globalSettings.KEYCLOAK_URL.endsWith("/")
                        ? globalSettings.KEYCLOAK_URL.slice(0, -1)
                        : globalSettings.KEYCLOAK_URL;
                    configUrl = "".concat(baseUrl, "/realms/").concat(realmName, "/.well-known/openid-configuration");
                    return [4 /*yield*/, fetch(configUrl, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            },
                        })
                        // If we get a successful response, the realm exists
                    ];
                case 1:
                    response = _a.sent();
                    // If we get a successful response, the realm exists
                    return [2 /*return*/, response.ok];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Handles the form submission for selecting a tenant.
     *
     * @param {React.SyntheticEvent} e - The form submission event.
     *
     * This function performs the following steps:
     * 1. Prevents the default form submission behavior.
     * 2. Sets the loading state to true and clears any previous errors.
     * 3. Trims the tenant name and checks if it is not empty.
     * 4. Sends a GraphQL query to check if the tenant exists in the database.
     * 5. If the tenant exists, retrieves the tenant ID.
     * 6. Checks if the realm associated with the tenant exists.
     * 7. Stores the tenant ID in local storage.
     * 8. Initializes Keycloak without auto-redirect.
     * 9. If not already authenticated, manually redirects to the login page.
     *
     * If any error occurs during these steps, it sets the error message, stops the loading state, and opens an error dialog.
     *
     * @throws {Error} If the tenant name is empty, tenant is not found, tenant realm is not found, or any other error occurs during the process.
     */
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var slug, response, _a, data, errors, tenantId, realmExists, initSuccess, err_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    setIsLoading(true);
                    setError(null);
                    if (intents >= 5) {
                        setError("Too many attempts. Please try again later.");
                        setIsLoading(false);
                        setOpen(true);
                        setIsDisabled(true);
                        localStorage.setItem("next-tenant-attempt", new Date().toISOString());
                        return [2 /*return*/];
                    }
                    else {
                        setIntents(intents + 1);
                    }
                    slug = tenant.trim();
                    if (!slug) {
                        setError("Please enter a tenant name");
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(globalSettings.HASURA_URL, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                query: "\n                    query GetTenantBySlug($slug: String!) {\n                        sequent_backend_tenant(where: {slug: {_eq: $slug}}) {\n                            id\n                            slug\n                        }\n                    }\n                ",
                                variables: { slug: slug },
                            }),
                        })];
                case 2:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        throw new Error(errors[0].message);
                    }
                    if (!((_b = data === null || data === void 0 ? void 0 : data.sequent_backend_tenant) === null || _b === void 0 ? void 0 : _b.length))
                        throw new Error("Tenant not found");
                    tenantId = data.sequent_backend_tenant[0].id;
                    return [4 /*yield*/, checkIfRealmExists("tenant-".concat(tenantId))];
                case 4:
                    realmExists = _c.sent();
                    if (!realmExists)
                        throw new Error("Tenant realm not found");
                    return [4 /*yield*/, initKeycloak(tenantId)];
                case 5:
                    initSuccess = _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_1 = _c.sent();
                    setError(err_1.message);
                    setIsLoading(false);
                    setOpen(true);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: loading ? (_jsx(CircularProgress, {})) : (_jsxs(StyledApp, { css: css, className: "select-tenant", children: [_jsx(Header, { appVersion: { main: globalSettings.APP_VERSION }, appHash: { main: globalSettings.APP_HASH }, logoUrl: logoImg }), _jsxs(BackgroundWrapper, { children: [_jsx(ContentWrapper, { children: _jsx(StyledCard, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h5", component: "h1", align: "center", gutterBottom: true, children: "Sequent Admin Portal" }), _jsx(Typography, { variant: "h6", component: "h2", align: "center", gutterBottom: true, children: t("common.label.selectTenant") }), _jsxs(Box, { component: "form", onSubmit: handleSubmit, sx: { mt: 2 }, children: [_jsx(TextField, { fullWidth: true, label: String(t("common.label.tenantName")), variant: "outlined", margin: "normal", value: tenant, onChange: function (e) { return setTenant(e.target.value); }, required: true, disabled: isDisabled, sx: { mb: 2 } }), _jsx(StyledButton, { fullWidth: true, variant: "contained", type: "submit", disabled: isLoading, children: isLoading
                                                        ? t("common.label.processing")
                                                        : t("common.label.continue") })] })] }) }) }), _jsx(Footer, { children: "Powered by Sequent Tech Inc" })] }), _jsx(Snackbar, { anchorOrigin: { vertical: "bottom", horizontal: "center" }, open: open, onClose: handleClose, autoHideDuration: 2000, children: _jsx(Alert, { severity: "error", variant: "filled", sx: { width: "100%", borderRadius: 2, paddingX: 8 }, children: _jsx(Box, { children: error }) }) })] })) }));
};
export default SelectTenant;
var templateObject_1, templateObject_2;
